export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-bold font-heading text-primary-400 whitespace-nowrap">
              榴莲视频
            </span>
            <p className="text-sm text-foreground-300 mt-3 leading-relaxed">
              榴莲视频聚合苹果视频、91视频网站、豆花视频、菠萝视频、红杏视频、青青草视频等海量高清影视资源，打造一站式视频播放与影视观看平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">影视推荐</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选视频</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题合集</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              开放合作中，更多优质影视站点即将加入榴莲视频聚合矩阵，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 text-center">
          <p className="text-xs text-foreground-400">
            &copy; 2026 榴莲视频 - 高清影视聚合平台。本站为影视资源聚合服务，内容来自合作站点。
          </p>
        </div>
      </div>
    </footer>
  );
}